module.exports = "<ul class=\"pager\">\n  <li class=\"prev\"><a href=\"#\">&lsaquo;</a></li>\n  <li class=\"next\"><a href=\"#\">&rsaquo;</a></li>\n</ul>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./~/component-pager/template.html
 ** module id = 78
 ** module chunks = 0
 **/